import "./Work.scss";
import works from "./WorkData";
import SectionTitle from "../../UI/SectionTitle/SectionTitle";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

// Стили Swiper (обязательные)
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
import { useEffect } from "react";

import WorkCard from "../../UI/WorkCard/WorkCard";

const Work = () => {
  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
      Toolbar: {
        display: ["close"],
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);

  return (
    <section className="works" id="portfolio">
      <div className="container">
        <div className="works__wrapper">
          <SectionTitle
            title="Мои работы"
            description="Я&nbsp;имел удовольствие работать с&nbsp;этими потрясающими проектами"
          />

          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={{
              prevEl: ".works-btn-prev",
              nextEl: ".works-btn-next",
            }}
            pagination={{ clickable: true }}
            className="works-swiper"
            breakpoints={{
              768: { slidesPerView: 2 },
              1440: { slidesPerView: 3 },
            }}
          >
            {works.map((work, index) => (
              <SwiperSlide key={`work-${index}`}>
                <WorkCard
                  title={work.title}
                  description={work.description}
                  avatar={work.avatar}
                  avatarWebp={work.avatarWebp}
                  index={index}
                  images={work.images}
                  imagesWebp={work.imagesWebp}
                  build={work.build}
                  code={work.code}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="works-btn-prev swiper-button-prev"></div>
          <div className="works-btn-next swiper-button-next"></div>
        </div>
      </div>
    </section>
  );
};

export default Work;
